import { apiService } from "./api";

export interface VehicleServiceHistorySummary {
  customer_name: string;
  vehicle_no: string;
  vin_no: string;
  total_visits: number;
}

export interface VehicleServiceVisit {
  jobcard_id: string;
  jobcard_no: string;
  status: string;
  service_type: string;
  visit_number: number;
  vin_no?: string;
  date_in: string;
  date_out: string;
  salesman: string;
  technician: string;
  customer_complaint: string;
  receiver_name: string;
  receiver_mobile: string;
  invoice_amount: number | null;
  payment_status: string | null;
  parts_issued_count: number;
  qc_status: string | null;
  qc_ref: string;
  gate_pass_no: string;
  service_progress: string[];
}

export interface VehicleServiceHistoryResponse {
  success: boolean;
  summary?: VehicleServiceHistorySummary;
  visits?: VehicleServiceVisit[];
  message?: string;
}

export async function fetchVehicleServiceHistory(params: {
  vehicle_no?: string | null;
  vin_no?: string | null;
}): Promise<VehicleServiceHistoryResponse> {
  const query: Record<string, string> = {};
  if (params.vehicle_no && String(params.vehicle_no).trim()) {
    query.vehicle_no = String(params.vehicle_no).trim();
  }
  if (params.vin_no && String(params.vin_no).trim()) {
    query.vin_no = String(params.vin_no).trim();
  }
  return apiService.get<VehicleServiceHistoryResponse>(
    "/pabws/vehicle/service-history",
    query,
    { includeAuthToken: true, authHeaderType: "Bearer" }
  );
}
